import { auth } from '../store/firebase'
import { store } from '../store'

const initializeButtonEvent = () => {
  const iframeSelector = '#jsd-widget' // Seletor do iframe
  const buttonSelector = '#help-button' // Seletor do botão dentro do iframe

  let buttonCheckInterval = null // Controla o intervalo de verificação
  let mutationObserver = null // Controla o observador do DOM

  const monitorIframeContent = () => {
    const iframe = document.querySelector(iframeSelector)

    if (!iframe) {
      console.log('Iframe não encontrado. Tentando novamente...')
      setTimeout(initializeButtonEvent, 1000) // Tenta novamente após 1 segundo
      return
    }

    const iframeContent = iframe.contentDocument || iframe.contentWindow.document

    if (!iframeContent) {
      console.log('Conteúdo do iframe não disponível. Tentando novamente...')
      setTimeout(monitorIframeContent, 1000)
      return
    }

    const attachButtonListener = () => {
      const button = iframeContent.querySelector(buttonSelector)

      if (!button) {
        console.log('Botão não encontrado dentro do iframe. Verificando novamente...')
        return
      }

      clearInterval(buttonCheckInterval) // Para o intervalo quando o botão for encontrado

      const handleButtonClick = () => {
        console.log('Botão de Suporte clicado!')

        // Pega o usuário logado state.user
        let user = null
        let userStr = null
        if (store.state.user) {
          user = store.state.user
          userStr = `${user.displayName} (${user.role})`
        }
        // Pega a empresa selecionada
        let company = null
        let companyStr = null
        // Verifica se a empresa está carregada no store
        if (store.state.companies && Array.isArray(store.state.companies) && store.state.company) {
          company = store.state.companies.find(
            company => company && company.identity === store.state.company
          )
          if (company) {
            companyStr = `${company.name} (${company.identity})`
          }
        }
        let patient = null
        let patientStr = null
        // Verifica se o paciente está carregado no store state.ultraFetal.patient
        if (store.state.ultraFetal && store.state.ultraFetal.patient) {
          patient = store.state.ultraFetal.patient
          if (patient && patient.name) {
            patientStr = `${patient.name} (${patient.patId})`
          }
        }
        // Pega o exame selecionado state.ultraFetal.gestationInteraction
        let study = null
        let studyStr = null
        if (store.state.ultraFetal && store.state.ultraFetal.gestationInteraction) {
          study = store.state.ultraFetal.gestationInteraction
          if (study && study.forms) {
            const studyDate = study.forms['gestationalAge.info.date']
            const dateStr = studyDate ? studyDate.toLocaleDateString() : ''
            studyStr = `${study.forms['gestationalAge.info.accessionNumber']} (${dateStr})`
          }
        }

        let description = '\n\n'
        if (userStr) {
          description += `Usuário: ${userStr}\n`
        }
        if (companyStr) {
          description += `Empresa: ${companyStr}\n`
        }
        if (patientStr) {
          description += `Paciente recente: ${patientStr}\n`
        }
        if (studyStr) {
          description += `Exame recente: ${studyStr}\n`
        }
        // Add url
        description += `URL: ${window.document.URL}`

        // Preenche o campo 'summary' com o texto padrão após um pequeno atraso
        setTimeout(() => {
          const descriptionField = iframeContent.getElementById('description')
          if (descriptionField) {
            // Define o valor usando Object.defineProperty
            Object.defineProperty(descriptionField, 'value', {
              writable: true,
              value: description
            })
            // Dispara eventos
            descriptionField.dispatchEvent(new Event('input', { bubbles: true }))
            descriptionField.dispatchEvent(new Event('change', { bubbles: true }))
            console.log(`Descrição definida como: ${description}`)
          }

          const emailField = iframeContent.getElementById('email')
          if (emailField) {
            // Define o valor usando Object.defineProperty
            Object.defineProperty(emailField, 'value', {
              writable: true,
              value: auth.currentUser.email
            })
            // Dispara eventos
            emailField.dispatchEvent(new Event('input', { bubbles: true }))
            emailField.dispatchEvent(new Event('change', { bubbles: true }))
            console.log(`Email definido como: ${auth.currentUser.email}`)
          }
        }, 1000)
      }

      // Remove event listeners antigos para evitar múltiplas adições
      button.removeEventListener('click', handleButtonClick)

      // Adiciona o evento ao botão
      button.addEventListener('click', handleButtonClick)

      console.log('Evento adicionado ao botão!')
    }

    // Inicia um intervalo para verificar periodicamente o botão
    buttonCheckInterval = setInterval(attachButtonListener, 1000)

    // Configura um observador para mudanças no DOM do iframe
    if (!mutationObserver) {
      mutationObserver = new MutationObserver(() => {
        console.log('Mudança detectada no DOM do iframe. Reanexando evento...')
        attachButtonListener()
      })

      mutationObserver.observe(iframeContent.body, {
        childList: true,
        subtree: true
      })

      console.log('Observador configurado para mudanças no DOM do iframe!')
    }
  }

  monitorIframeContent()
}

export const initJira = () => {
  console.log('Iniciando script...')
  initializeButtonEvent()
}



// WEBPACK FOOTER //
// ./src/utils/jira.js